/**
 * أداة تحسين أداء التطبيق
 * يتم استيرادها في index.js
 */

// تأجيل تحميل الموارد غير الحرجة
export const deferNonCriticalResources = () => {
  // تأجيل تحميل الصور غير المرئية
  if ("IntersectionObserver" in window) {
    const lazyImages = document.querySelectorAll('img[loading="lazy"]');
    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const img = entry.target;
            if (img.dataset.src) {
              img.src = img.dataset.src;
              img.removeAttribute("data-src");
            }
            imageObserver.unobserve(img);
          }
        });
      },
      { rootMargin: "50px" },
    );

    lazyImages.forEach((img) => imageObserver.observe(img));
  }
};

// تحسين تحميل الصفحة
export const optimizePageLoad = () => {
  // إخفاء loading indicator بعد تحميل React
  const hideLoader = () => {
    const loader = document.getElementById("loading-indicator");
    if (loader) {
      loader.style.opacity = "0";
      loader.style.transition = "opacity 0.3s ease";
      setTimeout(() => {
        loader.style.display = "none";
      }, 300);
    }
    window.reactLoaded = true;
  };

  // تأخير قصير للسماح بعرض المحتوى
  requestAnimationFrame(() => {
    requestAnimationFrame(hideLoader);
  });
};

// تحسين الصور - تحويل URL لـ Firebase Storage مع تحسين الحجم
export const getOptimizedImageUrl = (url, options = {}) => {
  if (!url) return url;

  const { width = 800, quality = 80 } = options;

  // للصور من Firebase Storage، نستخدم الـ URL كما هو
  // لكن يمكن إضافة معاملات تحسين إذا كان هناك CDN
  if (url.includes("firebasestorage.googleapis.com")) {
    // Firebase Storage لا يدعم تحسين الصور مباشرة
    // يمكن استخدام Cloud Functions للتحسين
    return url;
  }

  return url;
};

// Preload الصور المهمة
export const preloadCriticalImages = (imageUrls) => {
  imageUrls.forEach((url) => {
    if (url) {
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      document.head.appendChild(link);
    }
  });
};

// تحسين Web Vitals
export const measureWebVitals = () => {
  if (typeof window !== "undefined" && "performance" in window) {
    // قياس LCP
    const observer = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
    });

    try {
      observer.observe({ type: "largest-contentful-paint", buffered: true });
    } catch (e) {
      // المتصفح لا يدعم
    }

    // قياس CLS
    let clsValue = 0;
    const clsObserver = new PerformanceObserver((list) => {
      for (const entry of list.getEntries()) {
        if (!entry.hadRecentInput) {
          clsValue += entry.value;
        }
      }
    });

    try {
      clsObserver.observe({ type: "layout-shift", buffered: true });
    } catch (e) {
      // المتصفح لا يدعم
    }
  }
};

// تصدير دالة التهيئة الرئيسية
export const initPerformanceOptimizations = () => {
  // تحسين تحميل الصفحة
  optimizePageLoad();

  // تأجيل الموارد غير الحرجة
  if (document.readyState === "complete") {
    deferNonCriticalResources();
  } else {
    window.addEventListener("load", deferNonCriticalResources);
  }

  // قياس الأداء في وضع التطوير فقط
  if (process.env.NODE_ENV === "development") {
    measureWebVitals();
  }
};

export default initPerformanceOptimizations;
